import axios, { AxiosInstance } from "axios";
import { getNavigate } from "./routes/navigationHelper";
const baseURL = process.env.REACT_APP_BASE_URL;

export const api: AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
  timeout: 200000,
  validateStatus: (status) => {
    return status >= 200 && status < 300;
  },
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const navigate = getNavigate();
    const originalRequest = error.config;
    const status = error.response?.status;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      navigate("/error/401");
    } else if (status === 403) {
      if (
        error.response.data.Message ===
        "Unauthorized access: no active facilities."
      ) {
        navigate("/error/403", {
          state: {
            backendMessage: "Unauthorized access: no active facilities.",
          },
        });
      } else {
        navigate("/error/403");
      }
    } else if (
      status === 411 &&
      error.response.data.Message === "Code SSM: Token is no longer valid."
    ) {
      navigate("/unauthorized/411");
    } else if (status === 500) {
      navigate("/error/500");
    } else if (status === 503) {
      navigate("/error/503");
    }

    return Promise.reject(error);
  }
);
